<form class="space-y-3 sm:space-y-4 p-3 sm:p-4" (submit)="onGuardar($event)">
  @if (producto().stock_sucursal.id === 0 && producto().stock_sucursal.sucursal_id !== 0) {
    <div class="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start gap-2">
      <i class="bi bi-info-circle text-amber-600 mt-0.5"></i>
      <div>
        <p class="text-sm font-medium text-amber-800">Configuración heredada</p>
        <p class="text-xs text-amber-600">
          Este producto aún no tiene configuración propia en esta sucursal. Los valores
          mostrados se heredan de la sucursal principal. Al guardar, se creará una
          configuración específica para esta sucursal.
        </p>
      </div>
    </div>
  }
  <!-- Código -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Código</label>
    <input
      [formField]="$any(formProducto.codigo)"
      class="w-full px-3 py-2 text-sm border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 border-gray-300 hover:border-gray-400 bg-white sm:text-base"
      placeholder="Ingrese el código"
    />
  </div>

  <!-- Nombre -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Nombre</label>
    <input
      [formField]="$any(formProducto.nombre)"
      class="w-full px-3 py-2 text-sm border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 border-gray-300 hover:border-gray-400 bg-white sm:text-base"
      placeholder="Ingrese el nombre"
    />
  </div>

  <!-- Descripción -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Descripción</label>
    <textarea
      rows="5"
      [formField]="$any(formProducto.descripcion)"
      class="w-full px-3 py-2 text-sm border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none border-gray-300 hover:border-gray-400 bg-white sm:text-base"
      placeholder="Ingrese la descripción"
    ></textarea>
  </div>

  <!-- Precio Venta y Base -->
  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4">
    <div class="flex-1">
      <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Precio Venta</label>
      <app-input-number
        [formField]="$any(formProducto.precio_venta)"
        styleClass="w-full"
      />
    </div>
    <div class="flex-1">
      <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Precio Base</label>
      <app-input-number
        [formField]="$any(formProducto.precio_base)"
        styleClass="w-full"
      />
    </div>
  </div>

  <!-- Precio Venta Sucursal -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1"
      >Precio en esta sucursal <span class="text-gray-400 font-normal">(opcional)</span></label
    >
    <app-input-number
      [formField]="$any(formProducto.precio_venta_sucursal)"
      styleClass="w-full"
      placeholder="Dejar vacío para usar precio global"
    />
    <small class="text-gray-400 text-xs block mt-1"
      >Si se deja vacío, se usará el Precio Venta global para esta sucursal.</small
    >
  </div>

  <!-- Unidad de Medida -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Unidad de Medida</label>
    <app-select
      [filter]="true"
      filterBy="label,value"
      [emptyFilterMessage]="'No se encontraron unidades.'"
      [formField]="$any(formProducto.unidad_medida)"
      [options]="opcionesTipoUnidad()"
      [loading]="!opcionesTipoUnidad().length"
      styleClass="w-full"
    />
  </div>

  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4">
    <!-- Stock -->
    <div class="flex-1">
      <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Stock</label>
      <app-input-number
        [formField]="$any(formProducto.stock)"
        styleClass="w-full"
      />
    </div>
    <!-- Categoría -->
    <div class="flex-1">
      <div class="flex items-center gap-2 mb-1">
        <label class="text-xs sm:text-sm font-medium text-gray-700">Categoría</label>
        <button
          type="button"
          class="text-xs text-blue-600 hover:text-blue-800 font-medium"
          (click)="modalCrearCategoria.set(true)"
        >
          Crear +
        </button>
      </div>
      <app-select
        [filter]="true"
        filterBy="label,value"
        [emptyFilterMessage]="'No se encontraron unidades.'"
        [formField]="$any(formProducto.categoria_id)"
        [options]="opcionesCategorias()"
        [showClear]="true"
        styleClass="w-full"
      />
    </div>
  </div>

  <!-- Imagen -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Imagen</label>
    <div class="flex items-center gap-4">
      <app-producto-avatar
        [initialUrl]="imagenDisplayUrl()"
        [maxSizeMb]="maxImageSizeMb()"
        (imagenChange)="onChildImagenChange($event)"
        (validationError)="imagenError.set($event)"
      ></app-producto-avatar>
      <div class="flex-1">
        <p class="text-xs sm:text-sm text-gray-700 font-medium">Click en el círculo para cambiar</p>
        <small class="text-gray-500 text-xs block mt-1"
          >Formato: JPG, PNG o WEBP. Máximo: {{ maxImageSizeMb() }}MB</small
        >
        @if (imagenArchivo()) {
          <small class="text-green-600 text-xs block mt-1">{{ imagenArchivo()!.name }}</small>
        }
      </div>
    </div>
    @if (imagenError()) {
      <small class="text-sm text-red-600 text-xs block mt-1">{{ imagenError() }}</small>
    }
  </div>

  <!-- Tipo de Producto -->
  <div>
    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Tipo de Producto</label>
    <app-select
      [options]="opcionesTipoProducto()"
      [formField]="$any(formProducto.tipo_producto)"
      (onChange)="onTipoProductoChange($event)"
      styleClass="w-full"
    />
  </div>

  <!-- Activo + Controlar Stock + Es Servicio -->
  <div class="flex flex-col sm:flex-row gap-2 sm:gap-4">
    <label class="inline-flex items-center cursor-pointer">
      <input type="checkbox" [formField]="$any(formProducto.activo)" class="form-checkbox" />
      <span class="ml-2 text-xs sm:text-sm">Activo</span>
    </label>
    <label
      class="inline-flex items-center"
      [class.cursor-not-allowed]="isTipoReceta()"
      [class.opacity-60]="isTipoReceta()"
    >
      <input
        type="checkbox"
        [formField]="$any(formProducto.controlar_stock)"
        class="form-checkbox"
        [class.cursor-not-allowed]="isTipoReceta()"
      />
      <span class="ml-2 text-xs sm:text-sm">
        Controlar Stock
        @if (isTipoReceta()) {
          <span class="text-gray-400">(no aplica para recetas)</span>
        }
      </span>
    </label>
    @if (isTipoProducto()) {
      <label class="inline-flex items-center cursor-pointer">
        <input type="checkbox" [formField]="$any(formProducto.es_servicio)" class="form-checkbox" />
        <span class="ml-2 text-xs sm:text-sm">Es Servicio</span>
      </label>
    }
  </div>

  <!-- Opciones de Servicio -->
  @if (formProducto.es_servicio().value() == true) {
    <div class="border-t pt-3 sm:pt-4 mt-3 sm:mt-4">
      <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-2"
        >Opciones de Servicio</label
      >
      <div class="flex flex-col sm:flex-row gap-3 sm:gap-4">
        <label class="inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            [formField]="$any(formProducto.es_gestion_tiempo)"
            class="form-checkbox"
          />
          <span class="ml-2 text-xs sm:text-sm">Gestionar por tiempo</span>
        </label>
        @if (formProducto.es_gestion_tiempo().value() == true) {
          <div>
            <label class="block text-xs text-gray-500 mb-1">Duración (minutos)</label>
            <input
              type="number"
              [formField]="$any(formProducto.duracion_minutos)"
              class="w-full sm:w-24 px-2 py-1.5 border rounded text-sm sm:text-base"
              placeholder="60"
            />
          </div>
        }
      </div>
    </div>
  }

  <!-- Ingredientes de la Receta (solo tipo Receta) -->
  @if (isTipoReceta()) {
    <div class="border-t pt-3 sm:pt-4 mt-3 sm:mt-4">
      <div class="flex justify-between items-center mb-3">
        <h3 class="text-sm font-semibold text-gray-800">
          Ingredientes de la receta
          @if (receta()) {
            <span class="text-xs font-normal text-gray-500 ml-1"
              >(ID receta: {{ receta()!.producto_receta_id }})</span
            >
          }
        </h3>
        <app-button
          label="Agregar ingrediente"
          icon="bi bi-plus"
          variant="info"
          size="sm"
          (onClick)="agregarIngrediente()"
        />
      </div>

      @if (ingredientes.length > 0) {
        <!-- DESKTOP: fila horizontal -->
        <div class="hidden lg:flex flex-col gap-2">
          @for (ing of ingredientes; track ing.tempId; let i = $index) {
            <div class="flex items-center gap-2 p-2 bg-gray-50 rounded border border-gray-200">
              <div class="flex-1 min-w-0">
                <app-select
                  [options]="opcionesProductosIngrediente()"
                  [value]="ing.producto"
                  (onChange)="ing.producto = $event; onIngredienteSeleccionado(i)"
                  placeholder="Buscar ingrediente..."
                  [filter]="true"
                  [compareWith]="compareProductoById"
                  filterBy="nombre,codigo"
                  styleClass="w-full"
                />
              </div>
              <div class="w-16">
                <app-input-number [value]="ing.cantidad" (valueChange)="ing.cantidad = $event" [min]="0" placeholder="Cant." styleClass="w-full" />
              </div>
              <div class="w-32">
                <app-select [options]="unidadesCompatiblesParaIngrediente(ing)" [value]="ing.unidad" (onChange)="ing.unidad = $; onUnidadIngredienteCambiada(i)" styleClass="w-full" />
              </div>
              <div class="w-20 text-right text-xs text-gray-500">@if (ing.costoUnitario > 0) { S/ {{ ing.costoUnitario | number: '1.2-4' }} }</div>
              <div class="w-20 text-right text-xs font-medium">@if (ing.cantidad > 0 && ing.costoUnitario > 0) { S/ {{ ing.cantidad * ing.costoUnitario | number: '1.2-2' }} }</div>
              <app-button icon="bi bi-x-lg" variant="danger" [rounded]="true" size="sm" (onClick)="removerIngrediente(i)" />
            </div>
          }
        </div>

        <!-- MOBILE: cards -->
        <div class="lg:hidden flex flex-col gap-3">
          @for (ing of ingredientes; track ing.tempId; let i = $index) {
            <div class="bg-gray-50 rounded-lg border border-gray-200 p-3 flex flex-col gap-2">
              <div class="flex items-center justify-between">
                <span class="text-xs font-semibold text-gray-500 uppercase">Ingrediente {{ i + 1 }}</span>
                <button type="button" class="text-red-500 p-1" (click)="removerIngrediente(i)"><i class="bi bi-x-lg"></i></button>
              </div>
              <app-select
                [options]="opcionesProductosIngrediente()" [value]="ing.producto" (onChange)="ing.producto = $event; onIngredienteSeleccionado(i)"
                placeholder="Buscar ingrediente..." [filter]="true" [compareWith]="compareProductoById" filterBy="nombre,codigo" styleClass="w-full" />
              <div class="flex gap-2">
                <div class="flex-1">
                  <label class="text-[11px] text-gray-500 mb-0.5 block">Cantidad</label>
                  <app-input-number [value]="ing.cantidad" (valueChange)="ing.cantidad = $event" [min]="0" placeholder="Cant." styleClass="w-full" />
                </div>
                <div class="flex-1">
                  <label class="text-[11px] text-gray-500 mb-0.5 block">Unidad</label>
                  <app-select [options]="unidadesCompatiblesParaIngrediente(ing)" [value]="ing.unidad" (onChange)="ing.unidad = $; onUnidadIngredienteCambiada(i)" styleClass="w-full" />
                </div>
              </div>
              <div class="flex justify-between text-xs text-gray-500">
                @if (ing.costoUnitario > 0) { <span>Costo unit: S/ {{ ing.costoUnitario | number: '1.2-4' }}</span> }
                @if (ing.cantidad > 0 && ing.costoUnitario > 0) { <span class="font-medium text-gray-700">Subtotal: S/ {{ ing.cantidad * ing.costoUnitario | number: '1.2-2' }}</span> }
              </div>
            </div>
          }
        </div>
        <div class="flex justify-end pt-2">
          <span class="text-xs font-bold"
            >Costo total estimado: S/ {{ costoTotal() | number: '1.2-2' }}</span
          >
        </div>
      } @else {
        <div class="text-center text-gray-400 py-3 border border-dashed border-gray-300 rounded">
          <p class="text-xs">No hay ingredientes cargados para esta receta.</p>
        </div>
      }

      @if (receta() && ingredientes.length > 0) {
        <div class="flex justify-end pt-2">
          <app-button
            label="Guardar receta"
            icon="bi bi-check-lg"
            variant="success"
            [loading]="guardandoReceta()"
            (onClick)="guardarReceta()"
          />
        </div>
      }
    </div>
  }

  <div class="flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-2 pt-3 sm:pt-4">
    <button
      type="button"
      class="w-full sm:w-auto px-4 py-2.5 rounded text-sm sm:text-base bg-gray-200 hover:bg-gray-300 transition-colors"
      (click)="onCerrar()"
    >
      Cancelar
    </button>
    <button
      type="submit"
      class="w-full sm:w-auto px-4 py-2.5 rounded text-sm sm:text-base bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="formProducto().invalid()"
    >
      Guardar producto
    </button>
  </div>
</form>
<app-dialog
  header="Crear Nueva Categoría"
  [(visible)]="modalCrearCategoria"
  (onHide)="modalCrearCategoria.set(false)"
  size="sm"
>
  @if (modalCrearCategoria()) {
    <app-crear-categoria (cerrar)="onCrearCategoriaCerrada($event)" />
  }
</app-dialog>